<template>
  <div class="wrapper">
    <div class="searchconditions">
      <el-form :model="listForm" ref="listForm" inline>
        <el-form-item label="物料名称">
          <el-autocomplete
            :popper-append-to-body="false"
            v-model="productName"
            :fetch-suggestions="querySearch"
            placeholder="请输入物料名称"
            @select="(item) => handleSelect(item)"
          >
            <template slot-scope="{ item }">
              <div class="name">{{ item.productName }}</div>
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item prop="waringFlag" label="预警级别">
          <el-select
            v-model="listForm.waringFlag"
            clearable
            placeholder="请选择"
          >
            <el-option label="全部" value=""> </el-option>
            <el-option label="轻度" value="1"> </el-option>
            <el-option label="中度" value="2"> </el-option>
            <el-option label="重度" value="3"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="cyan" icon="el-icon-search" @click="searchList"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh" type="warning" @click="reset"
            >重置</el-button
          >
          <el-button
            icon="el-icon-download"
            type="primary"
            @click="exportDialog"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="list" border style="width: 100%" v-loading="loading">
      <el-table-column
        type="index"
        label="序号"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="productName"
        min-width="150"
        label="物料名称"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="companyName"
        min-width="120"
        label="生产工厂"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="productCount"
        min-width="120"
        label="窜货次数"
        align="center"
      >
      </el-table-column>
      <el-table-column
        min-width="120"
        prop="warningLevelName"
        label="预警级别"
        align="center"
      >
        <!-- <template slot-scope="scope">
          <span class="put-label label-1" v-if="">轻度度预警</span>
          <span class="put-label label-2" v-if="">中度预警</span>
          <span class="put-label label-3" v-if="">重度预警</span>
        </template> -->
      </el-table-column>
      <el-table-column min-width="120" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-view"
            @click="scanBtn(scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next, sizes, total, jumper"
      :page-sizes="[10, 15, 20]"
      :page-size="listForm.pageSize"
      :total="total"
      :current-page="listForm.pageNum"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    ></el-pagination>

    <!-- 导出 -->
    <el-dialog title="导出" :visible.sync="exportTimeDialog" width="40%">
      <el-form inline>
        <el-form-item label="导出范围">
          <el-date-picker
            v-model="exportTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            icon="el-icon-download"
            type="primary"
            size="medium"
            @click="exportCounterfeitGoodsReportXml"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportTimeDialog = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  statisticsPageList,
  getAllProductList,
  exportCounterfeitGoodsReport,
} from "@/common/api.js";
import axios from "axios";
export default {
  props: {},
  data() {
    return {
      loading: false,
      listForm: {
        pageSize: 10,
        pageNum: 1,
        productId: "",
        waringFlag: "",
      },
      productName: "",
      total: 0,
      list: [],
      productList: [],
      exportTime: null,
      exportTimeDialog: false,
    };
  },
  methods: {
    exportDialog() {
      this.exportTimeDialog = true;
    },
    // 导出
    exportCounterfeitGoodsReportXml() {
      let startStr = "";
      let endStr = "";
      if (this.exportTime && this.exportTime.length === 2) {
        startStr = this.formDate(this.exportTime[0]);
        endStr = this.formDate(this.exportTime[1]);
      }
      const params = {
        startDate: startStr,
        endDate: endStr,
      };
      this.$message({
        message: "开始下载，请稍后",
        type: "success",
      });

      exportCounterfeitGoodsReport(params)
        .then((res) => {
          const blob = new Blob([res]);
          console.log(res);
          const fileName = `窜货统计${params.startDate || ""}_${
            params.endDate || ""
          }.xls`;
          const elink = document.createElement("a"); // 创建a标签
          elink.download = fileName; // 为a标签添加download属性
          // a.download = fileName; //命名下载名称
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click(); // 点击下载
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink); // 释放标签
          this.loadingExt = false;
          axios.defaults.responseType = "json";
        })
        .catch((res) => {
          axios.defaults.responseType = "json";
        });
    },
    formDate(fromdate) {
      if (fromdate != null) {
        var date = new Date(fromdate);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var d = date.getDate();
        d = d < 10 ? "0" + d : d;
        return y + "-" + m + "-" + d;
      }
    },
    getPageList() {
      var params = this.listForm;
      this.loading = true;
      statisticsPageList(params).then((res) => {
        this.loading = false;
        if (res.errorCode == 200) {
          this.list = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    scanBtn(row) {
      this.$router.push({
        name: "feelingDetails",
        params: {
          productId: row.productId,
          companyId: row.companyId,
        },
      });
    },
    goDetail() {
      this.$router.push({
        name: "feelingDetails",
        params: {
          id: "",
        },
      });
    },
    getProdictList() {
      let params = {
        productName: "",
      };
      getAllProductList(params).then((res) => {
        this.productList = res.data;
      });
    },
    handleSelect(item) {
      console.log(item);
      this.productName = item.productName;
      this.listForm.productId = item.productId;
    },
    querySearch(queryString, cb) {
      var restaurants = this.productList;
      if (queryString == "" || queryString == undefined) {
        var results = queryString
          ? restaurants.filter(this.createFilter(queryString))
          : restaurants;
        cb(results);
      } else {
        let params = {
          productName: queryString || "",
        };
        getAllProductList(params).then((res) => {
          cb(res.data);
        });
      }
      // 调用 callback 返回建议列表的数据
    },
    searchList() {
      this.listForm.pageNum = 1;
      this.getPageList();
    },
    handleCurrentChange(cpage) {
      this.listForm.pageNum = cpage;
      this.getPageList();
    },
    handleSizeChange(psize) {
      this.listForm.pageSize = psize;
      this.getPageList();
    },
    // 搜索框重置
    reset() {
      this.$nextTick(() => {
        this.listForm = {
          pageSize: 10,
          pageNum: 1,
          productId: "",
          waringFlag: "",
        };
        this.productName = "";
        this.$refs["listForm"].resetFields();
        this.getPageList();
      });
    },
  },
  created() {},
  mounted() {
    this.getPageList();
    this.getProdictList();
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  .searchconditions {
    width: calc(100% - 30px);
    background: #fff;
    border-radius: 6px;
    margin-top: 10px;
    padding: 20px 15px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    .el-form {
      .el-form-item {
        display: inline-block;
        margin-right: 10px;
        vertical-align: top;
        margin: 5px 15px 5px 0px;
        /deep/.el-button {
          padding: 8px 15px;
          font-size: 12px;
          border-radius: 3px;
        }
      }
    }
  }
  .dialog-box /deep/.el-input {
    display: inline-block;
    width: 25%;
  }
  .put-label {
    padding: 5px 50px !important;
    margin-left: 20px;
    color: #ffffff;
  }
  .label-0 {
    background-color: #fac68a;
  }
  .label-1 {
    background-color: #b06822;
  }
  .label-2 {
    background-color: #d4011c;
  }
  .dialog-name {
    font-size: 18px;
    text-indent: 50px;
  }
  .dialog-tips1 {
    margin-top: 10px;
    text-indent: 50px;
  }
  .dialog-tips2 {
    font-size: 12px;
    margin-left: 20px;
  }
  .dialog-check {
    margin-left: 50px;
    margin-top: 10px;
    margin: 12px 0 20px 50px;
  }
  .desc {
    margin-top: 30px;
    margin-left: 50px;
  }
  .el-row {
    margin: 10px 0 0 !important ;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-color: #ffffff;
    padding: 5px 15px 0;

    .el-select {
      width: 100%;
    }
    .add-btn {
      float: left;
      padding: 0;
      margin-top: 5px;
      margin-bottom: 10px;
      .el-button {
        padding: 8px 15px;
        font-size: 12px;
        border-radius: 3px;
      }
    }
  }
  .code-detail .el-form-item {
    margin-bottom: 0;
  }
  /deep/ .el-autocomplete-suggestion {
    min-width: 100%;
    width: auto !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/system/feelingInfo/feelingStatistics.vue